import { ProductClickedEventParams } from "../events/product/ProductClickedEvent";
import { ProductAddedToCartEventParams } from "../events/product/ProductAddedToCartEvent";
import { ProductRemovedFromCartEventParams } from "../events/product/ProductRemovedFromCartEvent";
import { getCommonParams } from "./CommonParams";
import { mapProductTrackingData } from "./ProductObjectMapper";
import { ProductViewedEventParams } from "../events/product/ProductViewedEvent";
import { BUSINESS_VERTICAL, CHECKOUT_FLOW, EVENT_CATEGORY, FULFILMENT_CHANNEL, ALGOLIA_EVENT_TYPE } from "../constants/EventHelper";

export const createProductClickedEventParams = (
    productObj: any,
    inventoryStatus?: string | null,
    index: string | null = null,
    queryId: string | null = null
): ProductClickedEventParams => {
    return {
        ...getCommonParams(),
        BUSINESS_VERTICAL: BUSINESS_VERTICAL.GROCERY,
        EVENT_CATEGORY: EVENT_CATEGORY.GROCERY,
        PRODUCTS: [mapProductTrackingData(productObj, inventoryStatus)],
        INDEX: index,
        EVENT_TYPE: ALGOLIA_EVENT_TYPE.CLICK,
        QUERY_ID: queryId,
    }
}

export const createProductAddedToCartEventParams = (
    productObj: any,
    inventoryStatus?: string | null,
    quantity?: number | null,
    index?: string | null,
    queryId?: string | null,
    isPDP: boolean = false
): ProductAddedToCartEventParams => {
    return {
        ...getCommonParams(),
        BUSINESS_VERTICAL: BUSINESS_VERTICAL.GROCERY,
        EVENT_CATEGORY: EVENT_CATEGORY.GROCERY,
        FULFILMENT_CHANNEL: FULFILMENT_CHANNEL.ONLINE,
        CHECKOUT_FLOW: CHECKOUT_FLOW.E_COMMERCE,
        PRODUCTS: [mapProductTrackingData(productObj, inventoryStatus, quantity ?? 1)],
        INDEX: index ?? null,
        EVENT_TYPE: isPDP ? 'conversion' : 'conversion||click',
        EVENT_SUBTYPE: 'addToCart',
        QUERY_ID: queryId ?? null,
    };
}

export const createProductViewedEventParams = (
  products: Array<{ screenSection?: string; [key: string]: any }>,
  checkoutAddress: any,
  index: string | null = null,
  queryId: string | null = null
): ProductViewedEventParams => {
  const screenSection = products?.[0]?.swimlaneTitle ?? null
  return {
    ...getCommonParams(),
    BUSINESS_VERTICAL: 'grocery',
    PRODUCTS: products.map(product =>
      mapProductTrackingData(
        {
          details: product as any,
          checkoutAddress,
          ctaSublocation: product.screenSection,
        },
        null,
        null,
        true
      )
    ),
    INDEX: index,
    EVENT_TYPE: ALGOLIA_EVENT_TYPE.VIEW,
    QUERY_ID: queryId,
    SCREEN_SECTION: screenSection,
  }
}

export const createProductRemovedFromCartEventParams = (
  productObj: any,
  inventoryStatus?: string | null,
  quantity?: number | null
): ProductRemovedFromCartEventParams => {
  return {
    ...getCommonParams(),
    BUSINESS_VERTICAL: BUSINESS_VERTICAL.GROCERY,
    EVENT_CATEGORY: EVENT_CATEGORY.CHECKOUT,
    FULFILMENT_CHANNEL: FULFILMENT_CHANNEL.ONLINE,
    CHECKOUT_FLOW: CHECKOUT_FLOW.E_COMMERCE,
    PRODUCTS: [
      mapProductTrackingData(productObj, inventoryStatus, quantity ?? 1),
    ],
  }
}

export const createEmptyCartEventParams = (
  productArray: any,
  checkoutAddress: any
): ProductRemovedFromCartEventParams => {
  return {
    ...getCommonParams(),
    BUSINESS_VERTICAL: BUSINESS_VERTICAL.GROCERY,
    EVENT_CATEGORY: EVENT_CATEGORY.CHECKOUT,
    FULFILMENT_CHANNEL: FULFILMENT_CHANNEL.ONLINE,
    CHECKOUT_FLOW: CHECKOUT_FLOW.E_COMMERCE,
    PRODUCTS: productArray.map((product: any, index: number) => {
      const enrichedProduct = {
        details: {
          ...product,
          seller: {
            name: product?.sellerInfo?.name ?? '',
          },
        },
        checkoutAddress,
        productPosition: index + 1,
      }

      return mapProductTrackingData(
        enrichedProduct,
        product.reason,
        product.count ?? 1
      )
    }),
  }
}
